/** Drop-in "share on WhatsApp" button + modal. Prefill text from the page's data
 * (pass a function to capture live form state at click time). */
import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { AnimatePresence } from "framer-motion";
import { WhatsAppSendModal } from "./WhatsAppSendModal";

export const htmlToWaText = (html) => {
  const tmp = document.createElement("div");
  tmp.innerHTML = (html || "")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n\n")
    .replace(/<\/div>/gi, "\n")
    .replace(/<li[^>]*>/gi, "• ")
    .replace(/<\/li>/gi, "\n")
    .replace(/<(b|strong)>/gi, "*")
    .replace(/<\/(b|strong)>/gi, "*");
  return (tmp.textContent || "").replace(/\n{3,}/g, "\n\n").trim();
};

export const WaShareButton = ({
  getText, phone = "", title = "Share on WhatsApp", subtitle = "",
  attachments, downloadUrl, linkBlock, className = "", label = "WhatsApp",
  testId = "wa-share-btn", size = 13,
}) => {
  const [wa, setWa] = useState(null);
  const open = () => setWa({ text: typeof getText === "function" ? getText() : (getText || "") });
  return (
    <>
      <button type="button" onClick={open} data-testid={testId}
        className={className || "inline-flex items-center gap-1.5 rounded-full bg-[#25D366] px-4 py-2 text-xs font-bold text-white hover:bg-[#1DA851]"}>
        <MessageCircle size={size} /> {label}
      </button>
      <AnimatePresence>
        {wa && (
          <WhatsAppSendModal
            title={title} subtitle={subtitle}
            text={wa.text} onTextChange={(t) => setWa({ text: t })}
            phone={typeof phone === "function" ? phone() : phone}
            attachments={attachments} downloadUrl={downloadUrl} linkBlock={linkBlock}
            onClose={() => setWa(null)}
          />
        )}
      </AnimatePresence>
    </>
  );
};
